  <template>
    <el-table
      :data="tableData"
      :default-sort = "{prop: 'total_amount', order: 'descending'}"
      show-summary
      sum-text="Загалом">
      <el-table-column
        prop="category"
        label="Категорія">
      </el-table-column>
      <el-table-column
        prop="total_amount"
        sortable
        :formatter="amount_formatter"
        label="Кількісь">
      </el-table-column>
    </el-table>
  </template>

  <script>
    export default {
      props: ['tableData'],
      methods: {
        amount_formatter(row) {
            return Number(row.total_amount).toLocaleString();
        }
      }
    }
  </script>